import '@operato/property-editor/ox-property-editor-secret.js'
import './editors/entity-editor.js'
import './editors/property-editor.js'

import { OxGristEditorJson } from '@operato/app/grist-editor/ox-grist-editor-json.js'
import { OxGristRendererCrontab } from '@operato/app/grist-editor/ox-grist-renderer-crontab.js'
import {
  registerEditor as registerGristEditor,
  registerRenderer as registerGristRenderer,
  OxGristRendererJson5
} from '@operato/data-grist'
import { OxGristEditorCrontab } from '@operato/grist-editor/ox-grist-editor-crontab.js'
import { OxGristEditorPrivilege } from '@operato/app/grist-editor/ox-grist-editor-privilege.js'
import { OxGristEditorParameters } from '@operato/grist-editor/ox-grist-editor-parameters.js'
import { OxGristEditorData } from '@operato/grist-editor/ox-grist-editor-data.js'
import { OxPropertyEditor } from '@operato/property-editor'

import { ConnectionSelector } from './grist/connection-selector.js'
import { ConnectorSelector } from './grist/connector-selector.js'
import { TaskTypeSelector } from './grist/task-type-selector.js'

export default function bootstrap() {
  registerGristEditor('task-type', TaskTypeSelector)
  registerGristEditor('connector', ConnectorSelector)
  registerGristEditor('connection', ConnectionSelector)
  registerGristEditor('json', OxGristEditorJson)
  registerGristEditor('parameters', OxGristEditorParameters)
  registerGristEditor('crontab', OxGristEditorCrontab)
  registerGristEditor('data', OxGristEditorData)

  registerGristRenderer('crontab', OxGristRendererCrontab)
  registerGristRenderer('data', OxGristRendererJson5)

  OxPropertyEditor.register({
    secret: 'ox-property-editor-secret',
    'http-headers': 'property-editor-http-headers',
    'http-parameters': 'property-editor-http-parameters',
    'http-body': 'property-editor-http-body',
    'entity-selector': 'property-editor-entity-selector',
    'scenario-step-input': 'property-editor-scenario-step-input',
    'tag-scenarios': 'property-editor-tag-scenarios',
    'procedure-parameters': 'property-editor-procedure-parameters'
  })
}
